export enum ProfessionTypeEnum {
  DA = 'DA',
  DN = 'DN',
  RDH = 'RDH',
  FD = 'FD',
}
